import { fetchStockDetails } from './apiHelpers';

// Batch processing configuration
const FILTER_BATCH_SIZE = 100; // Number of stocks to fetch per batch (100×1=100 req/s, at limit)
const FILTER_BATCH_DELAY = 0; // No delay - maximum speed

export const filterStocks = async (
  stocks,
  filterOptions = {
    minMarketCap: 2_000_000_000,  // 2 billion (default)
    minEmployees: 50  // default
  },
  limit = 1000,  // default
  onProgress = null  // Progress callback: (current, total) => void
) => {
  console.log(`Starting to filter ${stocks.length} stocks. Filter options:`, filterOptions);
  console.log(`Batch config: size=${FILTER_BATCH_SIZE}, delay=${FILTER_BATCH_DELAY}ms`);

  const filteredStocks = [];
  const totalStocks = stocks.length;

  for (let i = 0; i < totalStocks && filteredStocks.length < limit; i += FILTER_BATCH_SIZE) {
    const batch = stocks.slice(i, i + FILTER_BATCH_SIZE);

    const batchPromises = batch.map(stock => fetchStockDetails(stock.symbol));
    const batchResults = await Promise.all(batchPromises);

    for (const details of batchResults) {
      if (details &&
          details.marketCap >= filterOptions.minMarketCap &&
          (details.employees >= filterOptions.minEmployees || details.employees == null)) {
        // Allow stocks with missing employee data (e.g., new IPOs)
        filteredStocks.push(details);

        if (filteredStocks.length >= limit) break;
      }
    }

    const processed = Math.min(i + FILTER_BATCH_SIZE, totalStocks);
    console.log(`Filter: Processed ${processed}/${totalStocks} stocks. Filtered: ${filteredStocks.length}`);

    // Report progress
    if (onProgress) {
      onProgress(processed, totalStocks);
    }

    // Delay before next batch (except for the last batch or if limit reached)
    if (i + FILTER_BATCH_SIZE < totalStocks && filteredStocks.length < limit) {
      await new Promise(resolve => setTimeout(resolve, FILTER_BATCH_DELAY));
    }
  }

  console.log(`Filtering complete. Returned ${filteredStocks.length} filtered stocks.`);
  return filteredStocks;
};